//import { Component, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


import { Component, Input, Output, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, HeaderService, NavigationService } from '@base/shared/services';
import { ProjectsService } from '@eyrus/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { get, omit } from 'lodash';
import { EyrusWarningModalComponent } from '@base-shared/components/warning-modal/warning-modal.component';
import { DailyLogsService } from '@eyrus/modules/daily-logs/daily-logs.service';


@Component({
  selector: 'dailylog-new-note-content',
  templateUrl: './new-note-modal.component.html',
  styleUrls: [
    './new-note-modal.component.sass',
    '../../../../../modules/daily-logs/submitter/notes/notes.component.sass'
  ]
})

export class NewNoteModalContent {

  noteForm: FormGroup;
  currentNote: any;
  loading: Boolean = true;
  readOnly: Boolean = false;
  private subscriptions: any = {};
  private isQuick: Boolean = false;
  isMobile: Boolean = false;

  @Input() currentNoteId;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private navigator: Location,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private api: ApiRequestsService,
    private helpers: HelpersService,
    private projectService: ProjectsService,
    private translate: TranslateService,
    private header: HeaderService,
    private navigation: NavigationService,
    private dailyLogService: DailyLogsService
    //
  ) { }



  /** TODO: use note.component */



  ngOnInit() {

    this.bootstrapForm({});

    this.currentNote = this.activeRoute.snapshot.paramMap.get('id') || this.currentNoteId;
    if (this.currentNote)
      this.getCurrentNote();

    this.subscriptions.queryParams = this.activeRoute.queryParams
      .subscribe(params => {
        this.readOnly = params.statusTypeName ? params.statusTypeName === 'submitted' : false;
      });
    this.loading = false;
    this.initializeQueryParams();
  }

  ngOnDestroy() {
    this.header.quickBack.next(null);
    const keys = Object.keys(this.subscriptions);
    keys.forEach((key) => this.subscriptions[key].unsubscribe());
  }

  /**
   * Cancel note creation / edition
   */
  cancel() {
    if (this.isMobile) {
      if (this.isQuick)
        return this.goBack();

      this.navigator.back();
    } else {
      this.closeModal({ saved: true });

      if (this.isQuick) {
        const params = omit(this.activeRoute.snapshot.queryParams, 'type');

        this.router.navigate([], {
          queryParams: params,
        });
      }
    }
  }

  /**
   * Close current Modal
   * @param {[type]} result [description]
   */
  closeModal(result?) {
    this.activeModal.close(result);
  }

  /**
   * create / edit current note
   */
  save({ value, valid }: { value: any, valid: boolean }) {
    if (!valid) {
      this.helpers.displayFormErrors(this.noteForm);
      return;
    }
    this.loading = true;

    this.helpers.setformAsValid(this.noteForm);

    this.projectService.createDailyLog()
      .then(res => {
        const dailyLogId = this.projectService.dailyLog;
        let payload: any = { ...value, dailyLogId };

        if (this.currentNote)
          payload = this.generatePatchOp(value);

        const action = this.currentNote ? this.api.dailyLogs.updateubmitterNotes(dailyLogId, this.currentNote, payload) :
          this.api.dailyLogs.storeSubmitterNotes(dailyLogId, payload);

        return action.toPromise();
      })
      .then((res) => {
        const _label = this.currentNote ? 'common.successfullyUpdated' : 'common.successfullyCreated';
        const _title = this.translate.instant('notes.note');
        const _msg = this.translate.instant(_label, { section: _title });

        this.helpers.successMessage('', _msg);

        this.cancel();
      })
      .catch(error => {
        this.loading = false;
        const errors = get(error, 'error.errors') || [];
        this.helpers.setFormError(this.noteForm, false);
        errors.forEach((err: any) => {
          const input = this.noteForm.get(err.fieldName);
          if (!input) return;
          input.setErrors({
            submitted: true,
            message: err.errorMessage
          });
        });
      });
  }

  /**
   * Get current note
   */
  private getCurrentNote() {
    // const note = this.projectService.currentNote || {};
    // const keys = Object.keys(note);
    // if (!keys.length)
    //   return;

    // this.bootstrapForm(note);

    const dailyLogId = this.projectService.dailyLog;
    this.api.dailyLogs.getSubmitterNote(dailyLogId, this.currentNote).toPromise()
      .then(result => {
        const note = result.dailyNoteListItem;
        this.bootstrapForm(note);
      }).catch(err => {
        this.helpers.errorMessage(err);
      });
  }

  /**
   * Initialize note form
   */
  private bootstrapForm(data?: any) {
    this.noteForm = this.formBuilder.group({
      note: [data.note || '', [Validators.required]],
    });
  }

  // Generate patch value
  private generatePatchOp(data) {
    return [
      {
        op: 'replace',
        path: '/note',
        value: data.note
      }
    ];
  }

  /**
   * List router params
   */
  private initializeQueryParams() {
    this.subscriptions.queryParams = this.activeRoute
      .queryParams
      .subscribe(params => {
        if (params.type && params.type === 'quick') {
          this.isQuick = true;
          this.header.quickBack.next({
            action: () => this.goBack()
          });
        }
      });
  }

  /**
   * Quick access go back
   */
  private goBack() {
    return this.navigation.navigate({
      type: 'basic',
      stepsBack: 2
    });
  }


  /****/


}